<template>
    <div style="display: inline;">
        <section class="institutes py-0 bg-sub-secondary-color institutes-page">
            <div class="container-fluid">

                <div :style="'min-height:200px'" class="institutes-list pt-4 position-relative" id="institutes-box">
                    <div v-if="show_loader" class="ajax_loader">
                        <img :style="'position: absolute; z-index: 10; top: 45%; left: 50%; width: 70px;'" :src="'/storage/ajax_loder.gif'
                            " />
                    </div>
                    
                    <div class="offers-parent" v-if="!this.show_loader">
                        <div v-if="courses.length > 0" class="row">
                        <div v-for="course_info in courses" :key="course_info.course.course_id"
                            class="col-lg-3 col-md-6">

                            <div class="card mx-0 shadow-sm offer border-0 institute-card rounded-10 mb-4">
                                <div v-if="course_info.course.sat_discount > 0"
                                    class="offer-icon sat-discount position-absolute">
                                    خصم يوم التأسيس -{{ course_info.course.sat_discount * 100 }}%
                                </div>
                                <div :style="course_info.course.sat_discount <= 0 ? 'top:18px' : ''"
                                    v-if="course_info.course.discount_obj.total_discounts"
                                    class="offer-icon institute-discount position-absolute">
                                    خصم المعهد
                                    -{{ formatNumber(course_info.course.discount_obj.total_discounts * 100) }}%
                                </div>
                                <a :href="course_info.course_link">
                                    <div class="institute-img d-inline-block position-relative">
                                        <img :src="course_info.course_image_thumb_md ? course_info.course_image_thumb_md : public_path + 'storage/default_images.png'"
                                            :alt="course_info.course.institute_name" class="card-img-top" />
                                    </div>
                                </a>

                                <div class="card-body rounded-10 bg-white">
                                    <h5 class="card-title institute-box-title">
                                        <a :href="course_info.course_link">
                                            معهد
                                            {{ course_info.course.institute_name }}
                                        </a>
                                    </h5>
                                    <h6 class="card-title course-box-title">
                                        <a :href="course_info.course_link">
                                            {{ course_info.course.name }}
                                        </a>
                                    </h6>
                                    <p class="mb-0">
                                        <i class="fas fa-map-marker-alt text-main-color"></i>
                                        {{ course_info.course.country }} ,
                                        {{ course_info.course.city }}
                                    </p>
                                    <p class="mb-0 overflow-hidden d-flex justify-content-between">
                                        <span v-if="
                                            course_info.course.study_period
                                        "><i class="fas fa-sun text-main-color"></i>
                                            {{ course_info.course.study_period }}</span>
                                        <span v-if="
                                            course_info.course.hours_per_week !=
                                            null
                                        ">
                                            <i class="fas fa-clock text-main-color"></i>
                                            {{
                                                course_info.course.hours_per_week
                                            }}
                                            ساعة
                                        </span>
                                        <span v-else>
                                            <i class="fas fa-book-open text-main-color"></i>
                                            <label>{{
                                                course_info.course.lessons_per_week
                                            }}
                                                درس</label>
                                        </span>
                                        <span>
                                            <i class="fas fa-signal text-main-color"></i>
                                            {{
                                                course_info.course.required_level
                                            }}
                                        </span>
                                    </p>
                                </div>
                                <div v-if="course_info.total_price == course_info.total_price_before_discount"
                                    class="card-footer bg-white overflow-hidden">
                                    <span class="float-left text-main-color">
                                        {{ course_info.total_price }}
                                         
                                    </span>
                                </div>
                                <div v-else class="card-footer bg-white overflow-hidden">
                                    <del class="del text-danger">{{ course_info.total_price_before_discount }}
                                         
                                    </del>
                                    <span class="float-left text-main-color">
                                        {{ course_info.total_price }}
                                         
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                        <div v-else>
                            <div class="alert alert-danger text-center">
                                لا يوجد عروض
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: [
        "offers_url",
        "public_path",
        "csrf_token",
        "request",
        "weeks",
    ],
    data() {
        return {
            courses: { data: {} },
            show_loader : true,
        };
    },
    methods: {

        get_courses: function (isFilter = false, current_page = null) {
            axios
                .get(this.offers_url, {
                    params: { 
                        country_id: this.request.country_id, 
                        city_id: this.request.city_id, 
                        start_date: this.request.start_date, 
                        weeks: this.weeks ?? 1, 
                    }
                })
                .then(response => {
                    this.courses = response.data;

                    this.show_loader = false
                });

        },
        formatNumber: function (number) {
            if (Number.isInteger(number)) {
                return number.toString();
            } else {
                return number.toFixed(1);
            }
        },

    },
    watch: { 
        
 
    },
    computed: {},
    mounted() {
        
    },
    beforeDestroy() {
    },
    beforeMount() {
        
        this.get_courses();

    },
    computed: {},
};
</script>
